import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';

const SurpriseContactsWithSongs = (props) => {
  return (
    <section className='surprise-contacts-with-songs'>
      <h2 className="title">רוצים להתאים שירים שונים לאנשי הקשר שלכם?</h2>
      <p className='text'>בחרו שירים נוספים והתאימו אותם לאנשים הקרובים לכם לפי בחירתכם</p>
      <Image src={require('./images/songs.jpg')} className='songs-image' alt='' />
      <a  className='another-song' href="#" onClick={() => props.selectAnotherSong()}>
        לבחירת שיר אחר
        <Image src={require('./images/arrow.svg')} alt='לקטלוג השירים' />
      </a>
    </section>
  );
};

export default SurpriseContactsWithSongs;
